import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '../../mui-styles-bridge.js';
import { TextField } from '@mui/material';
import {
  getValidationHelperText,
  validatePattern,
} from '../../utils/inputValidation';

const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
  textroot: {
    width: '100%',
    margin: 'auto',
  },
});

class SingleLinetext extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      answer: '',
    };
  }

  componentDidMount() {
    let answer_data = this.props.form.answer_data[this.props.data.key];

    if (answer_data && answer_data.answer) {
      this.setState({
        answer: this.props.form.answer_data[this.props.data.key].answer[0],
      });
    } else {
      if (
        this.props.data.data &&
        this.props.data.data.toString() &&
        this.state.answer == ''
      ) {
        this.setState({ answer: this.props.data.data });
        this.props.getDataFromComponent(
          { text_answer: this.props.data.data },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
      }

      const hasEmptyAnswerMount =
        !this.props.form.answer_data[this.props.data.key] ||
        !this.props.form.answer_data[this.props.data.key].answer ||
        !this.props.form.answer_data[this.props.data.key].answer[0] ||
        this.props.form.answer_data[this.props.data.key].answer[0] === '';

      if (
        this.props.data.auto &&
        this.props.data.auto.toString() &&
        hasEmptyAnswerMount
      ) {
        this.props.getDataFromComponent(
          { text_answer: this.props.data.auto },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
        this.setState({ answer: this.props.data.auto });
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const currentAnswerInStore =
      this.props.form.answer_data[this.props.data.key];

    // Handle STATIC prefilled data changes (props.data.data)
    // Static prefills should NOT overwrite user input
    if (
      this.props.data.data &&
      prevProps.data.data &&
      this.props.data.data != prevProps.data.data
    ) {
      // Check if user has already entered data in either local state or Redux store
      const userHasEnteredData =
        (this.state.answer &&
          this.state.answer !== '' &&
          this.state.answer !== prevProps.data.data) ||
        (currentAnswerInStore &&
          currentAnswerInStore.answer &&
          currentAnswerInStore.answer[0] &&
          currentAnswerInStore.answer[0] !== '' &&
          currentAnswerInStore.answer[0] !== prevProps.data.data);

      if (userHasEnteredData) {
        // Don't overwrite user's input with static prefilled data
        return;
      }

      // Only update if user hasn't entered anything
      this.props.getDataFromComponent(
        { text_answer: this.props.data.data },
        this.props.data.key,
        this.props.data.question_text,
        this.props.data.data
      );
      this.setState({ answer: this.props.data.data });
    }

    // Check if auto value changed and we should update
    const hasEmptyAnswer =
      !this.props.form.answer_data[this.props.data.key] ||
      !this.props.form.answer_data[this.props.data.key].answer ||
      !this.props.form.answer_data[this.props.data.key].answer[0] ||
      this.props.form.answer_data[this.props.data.key].answer[0] === '';

    const hasExistingAnswer =
      this.props.form.answer_data[this.props.data.key] &&
      this.props.form.answer_data[this.props.data.key].answer &&
      this.props.form.answer_data[this.props.data.key].answer[0] &&
      this.props.form.answer_data[this.props.data.key].answer[0] !== '';

    // Handle auto value changes (conditional prefills)
    // Auto values SHOULD overwrite user input when conditions change
    if (prevProps.data.auto !== this.props.data.auto) {
      if (this.props.data.auto && this.props.data.auto.toString()) {
        // Always set auto value when condition is met (override existing values)
        // This is intentional - conditional logic should take precedence
        this.props.getDataFromComponent(
          { text_answer: this.props.data.auto },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
        this.setState({ answer: this.props.data.auto });
      } else if (
        (!this.props.data.auto || !this.props.data.auto.toString()) &&
        hasExistingAnswer
      ) {
        // Clear field when auto becomes empty (condition no longer met)
        this.props.getDataFromComponent(
          { text_answer: '' },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
        this.setState({ answer: '' });
      }
    }
  }

  handleOnChange = (event) => {
    this.setState({ answer: event.target.value });
  };

  handleOnBlur = (event) => {
    let text = { text_answer: event.target.value };
    this.props.getDataFromComponent(
      text,
      this.props.data.key,
      this.props.data.question_text,
      this.props.data.data
    );
  };

  doNothing = () => {};

  render() {
    const { classes, data } = this.props;

    try {
      return (
        <div className={classes.root}>
            <TextField
              fontSize={14}
              fullWidth
              value={this.state.answer}
              disabled={this.props.data.read_only}
              placeholder={typeof this.props.data.data === 'object' ? this.props.data.data.placeholder : undefined}
              error={
                !validatePattern(this.state.answer, this.props.data.validation)
              }
              helperText={getValidationHelperText(
                this.state.answer,
                this.props.data.validation
              )}
              variant="outlined"
              label={typeof this.props.data.data === 'object' ? this.props.data.data.label : undefined}
              onChange={
                this.props.data.read_only ? this.doNothing : this.handleOnChange
              }
              onBlur={
                this.props.data.read_only ? this.doNothing : this.handleOnBlur
              }
            />
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    form: state.form,
  };
};

const mapDispatchToProps = {};

SingleLinetext.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SingleLinetext));
